
import React from "react";
import { MDBInput  } from 'mdb-react-ui-kit';


import Select from "react-select";

// reactstrap components
import {
Badge,
  Button,
  Card,
  CardBody,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  Modal,
  ModalBody,
  CustomInput,
  
 
} from "reactstrap";

import { v4 as uuid } from 'uuid';


const RechargeList = () => {
  const [modalClassic, setModalClassic] = React.useState(false);
  

  const [Client, setClient] = React.useState('');
  const [Channel, setChannel] = React.useState('');
  const [Previous_allotted, setPrevious_allotted] = React.useState('');
  const [Used, setUsed] = React.useState('');
  const [Add, setAdd] = React.useState('');
  const [Create_date, setCreate_date] = React.useState('');
  const [changesubmit, setChangesubmit] = React.useState(recharge_List);

    console.log(changesubmit);
  const toggleModalClassic = () => {
    setModalClassic(!modalClassic);
  };



  const handelSubmit = (e) => {
    e.preventDefault();  // Prevent reload

    const ids = uuid() // Creating unique id
    let uni = ids.slice(0, 8) // Slicing unique id

    // Fetching a value from usestate and 
    // pushing to javascript object
   let Client = Client, 
        Channel = Channel,
        Previous_allotted = Previous_allotted,
        Used = Used,
        Add = Add,
        Create_date = Create_date
      

    recharge_List.push({ 
        id: uni, 
        Client : Client, 
        Channel : Channel,
        Previous_allotted : Previous_allotted,
        Used : Used,
        Add : Add,
        Create_date : Create_date,
    })

      console.log(recharge_List);

    
}
  const recharge_List = [
    {
        id:'1', 
        Client:'Shivansh',
        Channel:'dummy',
        Previous_allotted:'dummy',
        Used:'dummy',
        Add:'dummy',
        Create_date:'dummy'
    },
    {
        id:'2', 
        Client:'kotilingam',
        Channel:'dummy',
        Previous_allotted:'dummy',
        Used:'dummy',
        Add:'dummy',
        Create_date:'dummy'
    },
    {
        id:'3',
        Client:'Devansh',
        Channel:'dummy',
        Previous_allotted:'dummy',
        Used:'dummy',
        Add:'dummy',
        Create_date:'dummy'
    }
]



  return (
    <>
      <div className="content pd-0">
      <Row>
        
        <Card className="mb-0">
            <CardBody className="scroll-height-450">
              <Col sm="12">
                <Row>
                  
                  <Col sm="4">
                  <h4 className="mt-4"><Button className="btn btn-link btn-round  btn-success" style={{"font-size" : "25px"}} onClick={toggleModalClassic}><i class="tim-icons icon-simple-add"></i></Button> Add Client </h4>
              
                  </Col>
                </Row>
              </Col>
              <Col sm="12">
                <Row>
                <Table responsive striped>
                  <thead>
                    <tr>
                      <th>Client</th>
                      <th> Channel </th>
                      <th> Previous Allotted </th>
                      <th> Used</th>
                      <th> Add</th>
                      <th> Create Date </th> 
                    </tr>
                  </thead>
                  <tbody>
                    {recharge_List.map((item) => {
                        return (
                          <tr>
                          <td>{item.Client}</td>
                          <td>{item.Channel}</td>
                          <td>{item.Previous_allotted}</td>
                          <td>{item.Used}</td>
                          <td>{item.Add}</td>
                          <td>{item.Create_date}</td>
                          </tr>
                        )
                    })}
                    {/* <tr>
                      <td>Koti</td>
                      <td>Sms</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>23-07-2023</td>
                      <td><a to="" className="text-info mr-2"><i class="tim-icons icon-pencil"></i></a> </td>
                   
                    </tr>
                    
                    <tr>
                    <td>Kumarswamy</td>
                    <td>Whatsapp Utility</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>23-07-2023</td>
                      <td><a to="" className="text-info mr-2"><i class="tim-icons icon-pencil"></i></a> </td>
                   
                    </tr> */}
                  </tbody>
                </Table>
                </Row>
                </Col>
            </CardBody>
         </Card>

         <Modal isOpen={modalClassic} toggle={toggleModalClassic}>
                      <div className="modal-header justify-content-center">
                        <button
                          aria-hidden={true}
                          className="close"
                          data-dismiss="modal"
                          type="button"
                          onClick={toggleModalClassic}
                        >
                          <i className="tim-icons icon-simple-remove" />
                        </button>
                        <h3 className="title title-up multicolortext">Add Recharge</h3>
                      </div>
                      <ModalBody className="modelbody py-5">
                      
                            <Row>
                              <Col sm="4" className="mb-2">
                              <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="Select Client"
            value={Client}
            onChange={(e) => setClient(e.value,e.target.value)}
             options={[
                  {
                    value: "",
                    label: "Select Client",
                    isDisabled: true
                   },
                  { value: "2", label: "Admin" },
                   { value: "3", label: "Super Admin" },
                   { value: "4", label: "Agent" },
                      ]}
            placeholder="Select Client"
           />
                              </Col>
                              <Col sm="4" className="mb-2">
                              <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="Select Channel"
            value={Channel}
            onChange={(e) => setChannel(e.value,e.target.value)}
             options={[
                  {
                    value: "",
                    label: "Select Channel",
                    isDisabled: true
                   },
                  { value: "2", label: "Sms" },
                   { value: "3", label: "whatsapp Utility" },
                   { value: "4", label: "whatsapp Marketing" },
                   { value: "5", label: "Rcs" },
                   { value: "6", label: "Ivr" },
                      ]}
            placeholder="Select Channel"
           />
                              </Col>
                              <Col sm="4" className="mb-2">
                              <MDBInput label='Previous Allotted'  type='text' onChange=
                        {e => setPrevious_allotted(e.target.value)}  value={Previous_allotted}/>
                              </Col>
                              <Col sm="4" className="mb-2">
                              <MDBInput label='Used'  type='text' onChange=
                        {e => setUsed(e.target.value)} value={Used} />
                              </Col>
                               <Col sm="4" className="mb-2">
                               <MDBInput label='Add'  type='text' onChange=
                        {e => setAdd(e.target.value)} value={Add}  />
                              </Col>
                             
                              
                              <Col sm="12" className="">
                              <Button type="submit" className="btn btn-icon btn-primary mt-4 pull-right" onClick={e => handelSubmit(e)}><i className="tim-icons icon-double-right"></i></Button>
                              </Col>
                              
                            </Row>
                       
                      </ModalBody>
                      </Modal>
      </Row>
      </div>
    </>
  )
}

export default RechargeList
